import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页', icon: 'ri-home-4-line' },
  { path: '/category/all', label: '电影分类', icon: 'ri-movie-2-line' },
  { path: '/about', label: '关于我们', icon: 'ri-information-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-xl border-b border-background-300/30'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2.5 group"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500/20 border border-primary-500/30">
              <i className="ri-movie-2-fill text-primary-400 text-lg md:text-xl"></i>
            </div>
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-50 tracking-wide">
              花生影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = link.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                    isActive
                      ? 'bg-primary-500/15 text-primary-400'
                      : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
                  }`}
                >
                  <i className={`${link.icon} mr-1.5`}></i>
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
              <input
                type="text"
                placeholder="搜索电影..."
                className="w-48 lg:w-56 pl-9 pr-4 py-2.5 rounded-lg bg-background-200/60 border border-background-300/40 text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-all duration-300"
              />
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-200 hover:bg-background-200/50 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-xl border-b border-background-300/30">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => {
              const isActive = link.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'bg-primary-500/15 text-primary-400'
                      : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
                  }`}
                >
                  <i className={`${link.icon} text-base`}></i>
                  {link.label}
                </Link>
              );
            })}
            <div className="pt-3 px-4">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索电影..."
                  className="w-full pl-9 pr-4 py-2.5 rounded-lg bg-background-200/60 border border-background-300/40 text-sm text-foreground-100 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-all duration-300"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}